import * as Yup from 'yup'
import { reverseShape } from 'Components/shared/helpers/reverse-shape'
import { validString, date, state, postcode, surcharge, dateRange } from 'Components/shared/helpers/validations'

const deliveryTypes = Yup.array().min(1) // may need to check format later

const States = Yup.object().shape({
    state: state.required(),
    postcodes: Yup.array().of(postcode).required()
})
const states = Yup.array().min(1).of(States)

export const LocationCreateSchema = Yup.object().shape(reverseShape({
    settingID: validString.optional(),
    areaName: validString.required(),
    deliveryTypes: deliveryTypes.required(),
    states: states,
    surcharge: surcharge,
    validFrom: date.required(),
    validTo: date.required().concat(dateRange)
}))